import React, { Component } from 'react';
import { ImagePicker } from 'react-file-picker'

import './css/SelectQuestion.css';
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";

class SelectQuestion extends Component {
    componentWillMount() {
        const question = StringUtils.removeImage(this.props.question);
        const questionImage = StringUtils.getLastImage(this.props.question);

        const options = this.props.options;
        if (this.props.shuffle) {
            for (let i = 0; i < options.length; i++) {
                ArrayUtils.shuffle(options[i]);
            }
        }
        let gapCount = 0;
        for (const subtask of this.props.subtasks) {
            gapCount += (subtask.match(/{%s}/g) || []).length;
        }
        const answers = new Array(gapCount).fill('');
        for (let i = 0; i < gapCount; i++) {
            answers[i] = options[i][0];
        }
        this.setState({
            answers: answers,
            question: question,
            questionImage: questionImage,
            options: options
        });
        this.props.saveAnswer(this.props.questionNumber, answers);
    }

    handleChange = (number, event) => {
        const answers = this.state.answers;
        answers[number] = event.target.value;
        this.setState({ answers: answers });
        this.props.saveAnswer(this.props.questionNumber, answers);
    };

    setQuestion = (event) => {
        const question = event.target.value;
        this.setState({ question: question });
        this.props.setQuestion(this.props.id, StringUtils.createTextWithImg(question, this.state.questionImage));
    };

    removeQuestionImage = () => {
        this.setState({ questionImage: null });
        this.props.setQuestion(this.props.id, this.props.question);
    };

    deleteQuestion = () => {
        const userIsSure = window.confirm("Na pewno?");
        if (userIsSure) {
            this.props.deleteQuestion(this.props.id);
        }
    };

    render() {
        let gapIndex = 0;
        const subtasks = this.props.subtasks.map((subtask, taskIndex) => {
            const content = subtask
                .split("{%s}")
                .map((item, index, array) => {
                    const key = "gap-" + taskIndex + "-" + index;
                    if (index < array.length - 1) {
                        const gap = gapIndex;
                        gapIndex += 1;
                        let optionIndex = 0;
                        const options = this.state.options[gap].map(option => (<option key={"option-" + gap + "-" + optionIndex++} value={option}>{option}</option>))
                        return (
                            <span key={key}>{StringUtils.parse(item)}
                                <select
                                    className="select"
                                    value={this.state.answers[gap]}
                                    onChange={(event) => this.handleChange(gap, event)}>
                                    {options}
                                </select>
                            </span>)
                    }
                    return (<span key={key}>{StringUtils.parse(item)}</span>);
                });

            return (
                <div key={"subtask-" + taskIndex} className="subtask">
                    {content}
                </div>
            );
        });

        const questionImage = (<img alt="external" className="external-image" src={this.state.questionImage} />);

        return (
            <div className="task-block select-question-edit">
                {this.props.isFirst ? '' : <button className="btn-square" onClick={this.props.moveUp}><i className="fas fa-arrow-up"></i></button>}
                {this.props.isLast ? '' : <button className="btn-square" onClick={this.props.moveDown}><i className="fas fa-arrow-down"></i></button>}
                <div className="question-number">Pytanie {this.props.number}</div>
                <div className="question">
                    <input type="text" placeholder="Pytanie" value={this.state.question} className="question-value" onChange={this.setQuestion} />
                    {this.state.questionImage != null ? questionImage : ''}
                    <ImagePicker
                        extensions={['jpg', 'jpeg', 'png']}
                        dims={{ minWidth: 100, minHeight: 100 }}
                        onChange={base64EncodedString => this.setState({ questionImage: base64EncodedString })}
                        onError={errMsg => console.log(errMsg)}
                        style={{ display: "inline-block" }}
                    >
                        <button className="btn-square"><i className="far fa-image" /></button>
                    </ImagePicker>
                    {this.state.questionImage != null ? <button className="btn-square" onClick={this.removeQuestionImage}><i className="fas fa-ban" /></button> : ''}
                    <button className="btn-square" onClick={this.deleteQuestion}><i className="far fa-trash-alt" /></button>
                </div>
                <div className="subtasks">
                    {subtasks}
                </div>
            </div>
        );
    }
}

export default SelectQuestion;
